var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.loadPage = function() {
	$(window).on('load', function() {
		$('body').addClass('page-loaded');
	})
	$(".restart-on-add").on("click", function() {
		console.log("Restarting page on add to cart");
		$("#cartModal").modal('close');
		setTimeout(() => {
			window.location.reload();
		}, 500)
	});
}();

FIGURE.titleInView = function() {
	if ($(".page-product-detail").length && $(".purchase-floater-header").length) {
		const observer = new IntersectionObserver(function(entries) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					$(".purchase-floater-header").addClass("title-in-view");
				} else {
					$(".purchase-floater-header").removeClass("title-in-view");
				}
			});
		}, {
			threshold: 0.02 // Trigger when 2% of h1 is visible
		});

		// Start observing the h1 element
		const h1Element = $("h1")[0];
		if (h1Element) {
			observer.observe(h1Element);
		}
	}
	if ($(".scroll-down-indicator").length) {
		$(window).on("scroll", function() {
			const $indicator = $(".scroll-down-indicator");
			const indicatorTop = $indicator.offset().top;
			const scrollTop = $(window).scrollTop();
			const windowHeight = $(window).height();

			const distanceFromTop = indicatorTop - scrollTop * 2;  // Distance from indicator to top of viewport
			const fadeZone = windowHeight * 0.8;	// Start fading when indicator is within top 30% of screen

			if (distanceFromTop <= fadeZone && distanceFromTop > 0) {
				const opacity = distanceFromTop / fadeZone;
				$indicator.css("opacity", opacity);
			} else if (distanceFromTop <= 0) {
				$indicator.css("opacity", 0);
			} else {
				$indicator.css("opacity", 1);
			}
		});
	}
}();

FIGURE.signupForm = function() {
	// Part 1 - Sign up shortcut
	$('.mailing-list').on('submit', e => {
		e.preventDefault();
		let inputs = [];
		$(".mailing-list input:not(button)").each((index, input) => {
			const name = $(input).attr('id');
			const value = $(input).val();
			if (value) {
				inputs.push(name + '=' + value);
			}
		});
		if (inputs.length) {
			let action = $(e.target).attr('action') + '?' + inputs.join('&');
			window.location.href = action;
		}
	});

	// Part 2 - Fill Out Form
	if ($("#signup-form").length) {
		const url = window.location.href;
		if (url.indexOf('?') > -1) {
			const inputs = url.split('?')[1].split('&');
			inputs.forEach(input => {
				const [name, rawValue] = input.split('=');
				const value = decodeURIComponent(rawValue || '');
				$(`#${name}`).val(value);
			});
			setTimeout(() => {
				var target = $("#signup-form");
				console.log({target});
		    if (target.length) {
		      $('html, body').animate({
		        scrollTop: target.offset().top
		      }, 500);
		    }
			},400)
		}
	}

}();

FIGURE.detailsFloater = (function() {
	"use strict";

	// Cache DOM elements and values
	const $window = $(window);
	const $floater = $(".purchase-floater");
	const $hankoOverlay = $(".hanko-bg-overlay");

	// Early return if required element doesn't exist
	if ($hankoOverlay.length === 0) {
		return;
	}

	let hankoBottom = 0;
	let isScrollBound = false;

	/**
	 * Toggle floater visibility based on scroll position
	 */
	function toggleFloater(scrollTop) {
		$floater.toggleClass("hidden", scrollTop < hankoBottom);
	}

	/**
	 * Handle scroll event
	 */
	function handleScroll() {
		const scrollTop = $window.scrollTop();
		toggleFloater(scrollTop);
	}

	/**
	 * Calculate hanko overlay bottom position
	 */
	function calculateHankoBottom() {
		const hankoHeight = $hankoOverlay.height();
		const hankoTop = $hankoOverlay.offset().top;
		hankoBottom = hankoTop + hankoHeight;
	}

	/**
	 * Check if floater should be active based on viewport width
	 */
	function updateFloaterState() {
		calculateHankoBottom();

		const isDesktop = $window.width() >= 768;

		if (isDesktop) {
			// Bind scroll event only once
			if (!isScrollBound) {
				$window.on("scroll", handleScroll);
				isScrollBound = true;
			}

			// Check initial state
			const scrollTop = $window.scrollTop();
			toggleFloater(scrollTop);
		} else {
			// Unbind scroll event on mobile
			if (isScrollBound) {
				$window.off("scroll", handleScroll);
				isScrollBound = false;
			}

			// Always show on mobile
			$floater.removeClass("hidden");
		}
	}

	/**
	 * Initialize
	 */
	function init() {
		// Debounce resize for better performance
		let resizeTimer;
		$window.on("load resize", function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(updateFloaterState, 100);
		});

		// Initial check
		updateFloaterState();
	}

	// Initialize immediately
	init();
})();

FIGURE.videoPlayer = function() {
	$(".play-pause-video").on("click", function(e) {
		console.log("Play/Pause button clicked");
		const target = $(e.target).closest(".play-pause-video");
		const videoEmbed = target.siblings(".video-embed");
		console.log({ target, videoEmbed });

		// Hide the p tag on first click
		const pTag = target.find("p");
		if (pTag.length && !pTag.hasClass("hidden")) {
			// Add transition class and fade out
			pTag.css("transition", "opacity 0.3s");
			pTag.css("opacity", "0");

			// After transition, set display none
			setTimeout(() => {
				pTag.css("display", "none");
				pTag.addClass("hidden"); // Mark as hidden
			}, 300);
		}

		if (videoEmbed.length) {
			const video = videoEmbed[0];

			if (video) {
				// Toggle muted state
				video.muted = !video.muted;

				// Update button appearance to show mute state
				if (video.muted) {
					target.addClass("muted").removeClass("unmuted");
				} else {
					target.removeClass("muted").addClass("unmuted");
				}
			}
		}
	});
	$(window).on("load resize", function() {
		$(".video-embed").each(function() {
			const video = this;
			const $video = $(video);

			if ($(window).width() < 768) {
				if ($video.data("mobile-video-link") && $video.hasClass("desktop-video")) {
					$video.find("source").attr("src", $video.data("mobile-video-link"));
					video.load();
					video.muted = true; // Ensure muted for autoplay
					video.play().catch(e => console.log("Video play failed:", e));
				}
				$video.removeClass("desktop-video").addClass("mobile-video");
			} else {
				if ($video.data("desktop-video-link") && $video.hasClass("mobile-video")) {
					$video.find("source").attr("src", $video.data("desktop-video-link"));
					video.load();
					video.muted = true; // Ensure muted for autoplay
					video.play().catch(e => console.log("Video play failed:", e));
				}
				$video.removeClass("mobile-video").addClass("desktop-video");
			}
		});
	});
}();

// FIGURE.updateCart = function() {
// 	if ($(".page-cart-index").length
// 		// || $(".page-cart-checkout").length
// 		// || $(".page-offering-index").length
// 		// || $(".page-offering-checkout").length
// 		// || $(".page-product-shop").length
// 		// || $(".page-product-listing").length
// 		// || $(".page-product-detail").length
// 		// || $(".page-product-category").length
// 		// || $(".page-product-category-detail").length
// 	) {
// 		const discountEligibleJS = $(".discount-eligible-js");
// 		const src = $(".page-offering-index").length || $(".page-offering-checkout").length
// 			? 'offering' : 'cart';
// 		const adders = [$(".btn-add-cart"), $(".add-your-full-allocation-button .btn")];
// 		const changers = [$(".qty.form-control"), $(".qty.custom-select")];
// 		adders.forEach(function(adder) {
// 			adder.on("click", function() {
// 				timedUpdateCartQty();
// 			});
// 		});
// 		changers.forEach(function(changer) {
// 			changer.on("change", function() {
// 				timedUpdateCartQty();
// 			});
// 		});
// 		$(window).on("load", function() {
// 			timedUpdateCartQty();
// 		});

// 		const updateCartQty = async function() {
// 			try {
// 				const res = await fetch(`/${src}/get_config_json/`);
// 				const json = await res.json();

// 				console.log({json});
// 				let count = parseInt(json.discount.count) || 12;
// 				let qty = 0;
// 				Object.values(json.cart.items)
// 					.filter(item => item.product_type === "Wine")
// 					.forEach(item => {
// 						qty += parseInt(item.quantity);
// 					})
// 				const progress = Math.round(Math.min(qty, 12)/count * 100, 0);
// 				$(".discount-eligible-progress-js .progress-bar").css("width", `${progress}%`);
// 				$(".discount-eligible-progress-js .progress-bar").attr("aria-valuenow", qty);
// 				$(".discount-eligible-progress-js .progress-bar").text(`${progress}%`);
// 				$(".discount-eligible-progress-js").removeClass('d-none');
// 				if (qty < count && $(".discount-eligible-js").length) {
// 					$(".discount-eligible-js").html(`<p>Add <strong>${count - qty}</strong> more bottle${count - qty > 1 ? 's' : ''} to your cart for <span class="nowrap"><strong>FREE Ground Shipping!</strong></span></p>`);
// 					$(".offering-rules").removeClass("mb-3");
// 				} else {
// 					$(".discount-eligible-js").html(`<p>Your order qualifies for <span class="nowrap"><strong>FREE Ground Shipping!</strong></span></p>`);
// 					$(".offering-rules").removeClass("mb-3");
// 				}
// 			} catch (error) {
// 				console.error("Error fetching allocation data:", error);
// 			}
// 		}
// 		const timedUpdateCartQty = function () {
// 			// if (discountEligibleJS.length) {
// 			setTimeout(() => {
// 				updateCartQty();
// 			}, 100);
// 			// }
// 		}
// 	}
// }();

FIGURE.updateCart = function() {
	if ($(".page-cart-index").length
		// || $(".page-cart-checkout").length
		// || $(".page-offering-index").length
		// || $(".page-offering-checkout").length
		// || $(".page-product-shop").length
		// || $(".page-product-listing").length
		// || $(".page-product-detail").length
		// || $(".page-product-category").length
		// || $(".page-product-category-detail").length
	) {
		const discountEligibleJS = $(".discount-eligible-js");
		const src = $(".page-offering-index").length || $(".page-offering-checkout").length
			? 'offering' : 'cart';
		const adders = [$(".btn-add-cart"), $(".add-your-full-allocation-button .btn")];
		const changers = [$(".qty.form-control"), $(".qty.custom-select")];
		adders.forEach(function(adder) {
			adder.on("click", function() {
				timedUpdateCartQty();
			});
		});
		changers.forEach(function(changer) {
			changer.on("change", function() {
				timedUpdateCartQty();
			});
		});
		$(window).on("load", function() {
			timedUpdateCartQty();
		});

		const updateCartQty = async function() {
		try {
			const res = await fetch(`/${src}/get_config_json/`);
			const json = await res.json();
			console.log({json});
			let count = parseInt(json.discount.count) || 12;
			let qty = 0;
			Object.values(json.cart.items)
				.filter(item => item.product_type === "Wine")
				.forEach(item => {
					qty += parseInt(item.quantity);
				})
			
			// Hide .bg-orange if no wine products, show if there are wine products
			if (qty === 0) {
				$(".bg-orange").hide();
			} else {
				$(".bg-orange").show();
			}
			
			// Update shipping message and active classes
			updateShippingMessage(qty, count);
			updateShippingActive(qty, count);
			
			const qtyInCurrentCase = qty % count || count;
			const progress = Math.round(qtyInCurrentCase / count * 100, 0);
				$(".discount-eligible-progress-js .progress-bar").css("width", `${progress}%`);
				$(".discount-eligible-progress-js .progress-bar").attr("aria-valuenow", qtyInCurrentCase);
				$(".discount-eligible-progress-js .progress-bar").text(`${progress}%`);
				$(".discount-eligible-progress-js").removeClass('d-none');
				if (qty % count === 0 && qty > 0) {
					$(".discount-eligible-js").html(`<p>Your order qualifies for <br><strong>FREE Ground Shipping!</strong></p>`);
					$(".offering-rules").removeClass("mb-3");
				} else {
					const bottlesNeeded = count - (qty % count);
					$(".discount-eligible-js").html(`<p>Add <strong>${bottlesNeeded}</strong> more bottle${bottlesNeeded > 1 ? 's' : ''} to your cart for <br><strong>FREE Ground Shipping on 12 bottle cases!</strong></p>`);
					$(".offering-rules").removeClass("mb-3");
				}
			} catch (error) {
				console.error("Error fetching allocation data:", error);
			}
		}
		const timedUpdateCartQty = function () {
			setTimeout(() => {
				updateCartQty();
			}, 100);
		}

		const updateShippingMessage = function(qty, count) {
			const $shippingMessage = $(".shipping-message-js");
			
			if (qty % count === 0 && qty > 0) {
				// Hide for exact multiples of 12 (12, 24, 36, etc.)
				$shippingMessage.hide();
			} else if (qty >= 1 && qty <= 5) {
				// Show Standard Ground Shipping for 1-5 bottles only
				$shippingMessage.html(`<strong>Standard Ground Shipping</strong>`).show();
			} else if (qty >= 6) {
				// Show Flat Rate Shipping for 6-11, 13-23, 25-35, etc.
				$shippingMessage.html(`<strong>Flat Rate Shipping</strong>`).show();
			} else {
				// Hide if qty is 0 or negative
				$shippingMessage.hide();
			}
		}

		const updateShippingActive = function(qty, count) {
			// Remove all active classes first
			$(".standard, .flat, .free").removeClass("active");
			
			if (qty % count === 0 && qty > 0) {
				// Exact multiples of 12 - activate free shipping
				$(".free").addClass("active");
			} else if (qty >= 1 && qty <= 5) {
				// 1-5 bottles - activate standard
				$(".standard").addClass("active");
			} else if (qty >= 6) {
				// 6+ bottles (except multiples of 12) - activate flat rate
				$(".flat").addClass("active");
			}
		}
	}
}();




